import angular from 'angular';
import UserActivityReportsComponent from './user-activity-reports-component';

export default angular.module('user-activity-reports', []).component('userActivityReports', new UserActivityReportsComponent());



// WEBPACK FOOTER //
// ./src/modules/admin-reports/components/user-activity-reports/user-activity-reports-module.js